<template>
    <div>
      <top-navbar></top-navbar>
      <div class="mb-5 background_color">
        <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Maintainence Management </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Maintainence List  </h6>
        <div class="container-fluid ">

        <div class="card custom_bdr_rds shadow p-2">
                <div class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>Supplier </b></td>
                           <td>Boeing</td> 
                          </tr>
                          <tr>
                            <td><b>Model & Series  </b></td>
                           <td>737-8</td> 
                          </tr>
                          <tr>
                            <td><b>Aircraft Number </b></td>
                           <td>1K016</td> 
                          </tr>
                        
                          <tr>
                            <td><b>Aircraft Serial Number   </b></td>
                           <td>44304</td> 
                          </tr>
                          <tr>
                            <td><b>Line Number  </b></td>
                           <td>4488</td>
                          </tr>
                          <tr>
                            <td><b>Engine Serial Number 1 </b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Engine Serial Number 2 </b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>APU Serial Number</b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Landing Serial Number </b></td>
                           <td></td> 
                          </tr>
                         
                          
                         
                           
                        </tbody>
                 
                 
                      </table>

      <div class="d-flex align-items-center">
  <!-- Tabs -->
   <b-col style="margin-left: -10px;" cols="12" md="" class="">
      <b-button @click="tab1()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
        Detailed Specification
      </b-button>
      <b-button @click="tab2()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
       ARL
      </b-button>
      <b-button @click="tab3()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
    Airworthiness Directive
      </b-button>
      <b-button @click="tab4()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
   MPD 01-01-2024
      </b-button>
      <b-button @click="tab5()" variant="primary" size="sm" class=" bdr-rad me-1 mb-1">
    MPD 15-9-2024
      </b-button>
     
    </b-col>

  <!-- Advanced Search tab aligned to the right -->
 <div class=" ms-auto">

      <button class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad" @click="tab6()">Advanced Search</button>

  </div> nav-item2
</div>

           <div class="mt-1 ms-1"  v-for="pdffile in pdffiles" :key="pdffile.id">
            <a @click="loadsavefile(pdffile.id)"  class="mb-1 mt-0 link_a">
            {{ pdffile.file_name }}
          </a>
                </div>
                </div>
                </div>


        
<b-container style="padding: 0px;" fluid class=" background_color ">
  <b-row class=""> <!-- gx = horizontal gap, gy = vertical gap -->
    <!-- Search Input -->
  

    <!-- Buttons -->
    <div class="container-fluid">

  <ul class="nav nav-tabs">
    <li class="nav-item nav-item2">
      <a class="nav-link  active point top-bdr-rad" @click="highlight()"> HIGHLIGHTS</a>
    </li>
    <li class="nav-item nav-item2">
      <a class="nav-link nav_link " @click="section2()">SYSTEMS AND POWERPLANT MAINTENA</a>
    </li>
    <li class="nav-item nav-item2">
      <a class="nav-link nav_link" @click="section3()"> STRUCTURAL MAINTENANCE PROGRAM</a>
    </li>
    <li class="nav-item nav-item2">
      <a class="nav-link nav_link" @click="section4()"> ZONAL INSPECTION PROGRAM</a>
    </li>
    <li class="nav-item nav-item2">
      <a class="nav-link nav_link" @click="section5()">  TASKS SORTED BY INTERVAL</a>
    </li>
    <li class="nav-item nav-item2">
      <a class="nav-link nav_link" @click="section6()"> TASKS SORTED BY MPD ITEM NUMBER</a>
    </li>
    <li class="nav-item nav-item2">
      <a class="nav-link nav_link" @click="section7()"> TASKS SORTED BY MRB ITEM NUMBER</a>
    </li>
    <li class="nav-item nav-item2">
      <a class="nav-link nav_link" @click="section8()"> TASKS SORTED BY TASK CARD NUMBE</a>
    </li>
  
  </ul>
</div>

    <b-col cols="12" md="auto">
      <b-input-group size="sm" style="max-width: 225px;">
        <b-form-input
          id="filter-input"
          class="bdr-rad mb-1"
          v-model="filter"
          @input="loadMiinventory()"
          type="search"
          placeholder="Search"
        />
      </b-input-group>
    </b-col>
    <b-col cols="12" md="auto" class="d-flex align-items-center">
      <span class="custom-breadcrumb"><b>Showing {{ totalRows }} items.</b></span>
    </b-col>

    <!-- Item Count -->
   
  </b-row>
</b-container>
  
          <div class="card bdr-rad2 mt-1 shadow p-2 ">
            <div class="card-body mb-4">
              <div class="d-flex justify-content-center" v-if="isLoading">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div class="table-responsive ">
                  <b-table
                  responsive
                  style="font-size: small;"
                  class="table-hover"
                  :items="all_datas"
                  :fields="fields"
                  :current-page="currentPage"
                  head-variant="dark"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  show-empty
                  small
                >
                <template #thead-top>
                    <tr>
                      <th colspan="3" class="text-center font-weight-bold text-uppercase" style="background-color: #e6f2ff; border-bottom: 1px solid #000;">
                        HIGHLIGHTS
                      </th>
                    </tr>
                </template>


             

                <template #head(section)="data">
  <div class="d-flex flex-column">
    <span>Section</span>
    <b-form-input
      v-model="columnFilters.section"
      placeholder="Search"
      size="sm"
      class="mt-1"
       @input="loadMiinventory()"
    />
  </div>
</template>

<template #head(item)="data">
  <div class="d-flex flex-column">
    <span>Item</span>
    <b-form-input
      v-model="columnFilters.item"
      placeholder="Search"
      size="sm"
      class="mt-1"
       @input="loadMiinventory()"
    />
  </div>
</template>

<template #head(description_of_change)="data">
  <div class="d-flex flex-column">
    <span>Description of Change</span>
    <b-form-input
      v-model="columnFilters.description_of_change"
      placeholder="Search"
      size="sm"
      class="mt-1"
       @input="loadMiinventory()"
    />
  </div>
</template>






       
               
  
  
      <!-- <template #cell(C_name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template> -->
  
      <template #cell(actions)="row">
      
        <!-- <b-button style="background-color: rgb(71, 144, 255);"  size="sm"  class="mr-1 custom-btn">
          View
        </b-button> -->
        <!-- @mouseenter="info(row.item.idCustomer)" -->  
      
        <div class="dropdown">
    <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
      Action
    </button>
    <div class="dropdown-menu bdr-rad">
      <a class="dropdown-item mouse-cursor" @click="moreinfo(row.item.idProduct)">View</a>
      <a class="dropdown-item mouse-cursor"  @click="Update(row.item.idProduct)">Update</a>
     
    </div>
  </div>
      </template>
  
      <template #cell(number)="row">
                   {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1)*10 + row.index + 1 }} 
                    </template>
      <template #cell(P_code1)="row">
       <a href="/" > {{ row.item.P_code }}</a>
  </template>
  
     
    </b-table>
  
    <!-- <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
        <b-pagination 
      @change="pageChanged" 
      v-model="currentPage" 
      pills 
      :total-rows="totalRows" 
      :per-page="perPage" 
      size="sm">
    </b-pagination>
    </b-col> -->
                </div>
              </div>
            </div>
          </div>
          <br><br>
        </div>
        
      </div>
    
      <content-footer></content-footer>
    </div>
  </template>
  
    
    <script>
   
   import axios from 'axios';
   import authService from '@/auth.service';
   import TopNavbar from '../../layout/TopNavbar.vue';
   import ContentFooter from '../../layout/ContentFooter.vue'
  import DatePicker from 'vue2-datepicker';
   import 'vue2-datepicker/index.css';
    
    
    
    export default {
      components :{
         
          TopNavbar,
          ContentFooter,
          DatePicker,
          
      },
    
        mounted(){
      this.loadMiinventory()
      this.loaddata()
        },
       
        computed: {
          
    
    
    
        },
    
        data() {
      return {
        currentPage: 1,
        mcustomers:[],
        all_datas:[],
        pdffiles:[],
      search: "",
      access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        permissions:authService.isPermission(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        columnFilters: {
        section: '',
        item: '',
        description_of_change: '',
    
        },
          FromDate: null,
          ToDate: null,
        filterOn: [],
        totalRows: '',
        
        perPage:15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        fields: [
        //   { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
          { key: 'section', label: 'Section', sortable: true,  },
          { key: 'item', label: 'Item', sortable: true  },
          { key: 'description_of_change', label: 'Description of Change', sortable: true  },
       
        //   { key: 'status', label: 'Status', sortable: true ,  },
        //   { key: 'created_date', label: 'Created Date', sortable: true ,  },
         
          
        //   { key: 'actions', label: 'Actions', class:'width-custom3', }
        ],
          
        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },
        isLoading: true, 
    
       
      };
      },
    
  
   
  
    
        
    
    
       methods:{ 
  
  
  
   
  async loaddata() {

            console.log(this.rows);

      try {
       // this.isLoading = true;
        const { data } = await axios.post('/mproduct/pdffilenameload',{

          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        if(data.status==200){
this.pdffiles = data.pdffile
        }



        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },
  async loadsavefile(id){
      this.$router.push('/Pdf/indexload?id='+id);

    },
  
  
  
  
  
  
    
      async info(idCustomer) {
    console.log(idCustomer);
    try {
      const { data} = await  axios.get('/mcustomer/view?id='+idCustomer,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.infoModal.content = data.item_list
       this.$root.$emit('bv::show::modal', this.infoModal.id)
      
      
    } catch (error) {
      console.log(error.response);
    }
  },
    async moreinfo(idproduct) {
  
  this.$router.push('/mproduct/view?id='+idproduct);
  
  },
  async productCreate() {
  
  this.$router.push('/pdf/create');
  
  },
  
  async highlight() {
  
  this.$router.push('/Pdfmdpsep/index');
  
  },
  async section2() {
  
  this.$router.push('/Pdfmdpsep/indextab2');
  
  },
    async tab2(){
      this.$router.push('/Pdfarl/indextab1');
    },
  async section3() {
  
  this.$router.push('/Pdfmdpsep/indextab3');
  
  },
  async section4() {
  
  this.$router.push('/Pdfmdpsep/indextab4');
  
  },
  async section5() {
  
  this.$router.push('/Pdfmdpsep/indextab5');
  
  },
  async section6() {
  
  this.$router.push('/Pdfmdpsep/indextab6');
  
  },
  async tab6(){
      this.$router.push('/Pdf/indexsearch');
    },
  async section7() {
  
  this.$router.push('/Pdfmdpsep/indextab7');
  
  },
  async section8() {
  
  this.$router.push('/Pdfmdpsep/indextab8');
  
  },
  async tab3(){
      this.$router.push('/pdf/index');
    },
  async tab4(){
      this.$router.push('/Pdfmdpjan/index');
    },
    async tab5(){
      this.$router.push('/Pdfmdpsep/index');
    },
  
  
      // onFiltered(filteredItems) {
      //     // Trigger pagination to update the number of buttons/pages due to filtering
      //     this.totalRows = filteredItems.length
      //     console.log(totalRows);
      //     this.currentPage = 1
      //   },
    
        async loadMiinventory(page = this.currentPage) {
          // const storedPermissions = this.permissions;
          // const permissionsArray = JSON.parse(storedPermissions);
          // console.log(permissionsArray);
           console.log("aaaaaaaddd");
         
      
        try {
          const { data} = await  axios.get('/mproduct/indexmpdsep',{
  
            params: {
              page: page,
              perPage: this.perPage,
              filter: this.filter,
              columnFilters: this.columnFilters,
              FromDate: this.FromDate,
              ToDate: this.ToDate,
            },
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
           this.all_datas = data.all_data;
          this.totalRows = data.total_count;
          this.currentPage = data.page;
          this.isLoading = false;
          
        } catch (error) {
          console.log(error.response);
        }
      },
  
      pageChanged(page) {
        console.log(page);
       this.loadMiinventory(page);
   },
  
  
      
       
    
     
    
    
    
    
    
    }
    
    
    
    };
    
    </script>
    
    <style >
  
  
    .button1{
      width: 10px !important;
    }
    .border1{
      border: none;
      background-color: #0d6efd;
    }
    .font-color1:hover{
      color: black !important;
      cursor: pointer;
    }
    .manage-boder{
        border-bottom: 2px solid #007bff;
        border-top: 2px solid #007bff;
        padding-bottom: 10px !important;
        padding-top: 10px !important;
        
        }
    .border-radius0{
          border-radius:0px !important ;
    }
    .font1{
          font-size: 13px !important;
       
        }
        .font-bold1{
          font-weight: bold;
        }
        .manage-boder{
        border-bottom: 2px solid #E9E9E3;
        border-top: 2px solid #E9E9E3;
        padding-bottom: 10px !important;
        padding-top: 10px !important;
        
        }
        .font1{
          font-size: 13px !important;
       
        }
        .font-bold1{
          font-weight: bold !important;
        }
        .colr1{
            color:#A5A5A3;
            
        }
        .decoration{
        text-decoration: none;
        color:#A5A5A3  ;
      }
      .width7{
        width: 250px;
      }
      .bg-mycoolor{
        background-color: #a4d2f3 !important;
  
      }
     
    .modal-footer{
      text-align: right !important;
      display: block;
    }
  
    .pfimg3 {
    padding-left: 10px;
  }
  .decoration {
    text-decoration: none;
  }
  .width-custom3 {
    width: 180px;
  }
  .date-placeholder {
    position: absolute;
    top: 5px;
    left: 12px;
    pointer-events: none;
    color: #6c757d;
  }
  
  
    
    </style>